import * as React from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

/**
 * ComboBox
 * Props:
 *  - options: Array of option objects (e.g. [{ label: 'One' }, ...]) or strings
 *  - label:  string for the TextField label
 */
export default function ComboBox({ options = [], label = "", onChangeFunc }) {
  // ensure we pass an array
  const opts = Array.isArray(options) ? options : [];

  // if options are objects with 'label' property, provide getOptionLabel
  const getOptionLabel = (option) => {
    if (!option && option !== 0) return "";
    if (typeof option === "string") return option;
    return option.label ?? String(option);
  };

  return (
    <div>
      <Autocomplete
        disablePortal
        options={opts}
        getOptionLabel={getOptionLabel}
        sx={{ width: 200 }}
        onChange={(e) => {onChangeFunc(e.target.firstChild.data)}}
        renderInput={(params) => <TextField {...params} label={label} />}
      />
    </div>
  );
}

ComboBox.propTypes = {
  options: PropTypes.array,
  label: PropTypes.string,
};